let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8oHQC")).then(() => parcelRequire('4KYwB'));